<template>
  <v-dialog v-model="show" persistent lazy max-width="600">
    <v-card>
      <v-card-title v-if="document" class="title">Удалить документ {{document.name}}?</v-card-title>
      <v-card-text></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="closeDialog()">Закрыть</v-btn>
        <v-btn v-if="!done" flat color="pink" @click.native="doDelete()">Удалить</v-btn>
        <v-btn v-if="done" flat color="green" @click.native="closeDialog()">Готово</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DocumentDeleteDialog',
  props: ['value', 'document'],
  data () {
    return {
      loading: false,
      done: false
    }
  },
  methods: {
    async doDelete () {
      this.loading = true
      await this.$store.dispatch('deleteDocument', this.document.id)
      this.done = true
      this.loading = false
      this.$emit('done')
    },
    closeDialog () {
      this.loading = false
      this.done = false
      this.show = false
    },
    fetchData() {
      this.$store.dispatch('getDocumentById', this.$route.params.document_id)
        .then((response) => {
          this.document = response.data
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (newValue) {
        if (!newValue)
          this.$emit('close')
      }
    }
  }
}
</script>